import { AxiosClientFactory } from '../../../common/helpers/AxiosClientFactory';
import { CommandResult } from '../../../common/helpers/CommandResult';

export const putFollowUpReminder = async (personId: string | number, loanId: string | number, followUpReminder: boolean): Promise<CommandResult> => {
    const result = await AxiosClientFactory
        .getInstance()
        .put(`api/applicants/${personId}/consumerloans/${loanId}/followUpReminder`, { followUpReminder });

    return new CommandResult(result);
};
